import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssuePresignedUrlInput,
  CreateIssuePresignedUrlResponse,
  MutationCreateAccidentIssueDocumentPresignedUploadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateAccidentIssueDocumentPresignedUploadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssuePresignedUrlInput]?: CreateIssuePresignedUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse>;
}

// SearchAccidentIssueDocument Service
export const { createAccidentIssueDocumentPresignedUrl, useCreateAccidentIssueDocumentPresignedUrl } = ((): {
  createAccidentIssueDocumentPresignedUrl: ServiceMethod;
  useCreateAccidentIssueDocumentPresignedUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateAccidentIssueDocumentPresignedUploadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssuePresignedUrlInput, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse> => {
        const args: MutationCreateAccidentIssueDocumentPresignedUploadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createAccidentIssueDocumentPresignedUploadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createAccidentIssueDocumentPresignedUploadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createAccidentIssueDocumentPresignedUrl: fetch,
    useCreateAccidentIssueDocumentPresignedUrl: useService,
  };
})();
